export default __webpack_public_path__ + "static/media/refreshNewMobile.97356a75.svg";